import { render, staticRenderFns } from "./ScrollCenterDialog.vue?vue&type=template&id=215578bf&scoped=true"
import script from "./ScrollCenterDialog.vue?vue&type=script&lang=js"
export * from "./ScrollCenterDialog.vue?vue&type=script&lang=js"
import style0 from "./ScrollCenterDialog.vue?vue&type=style&index=0&id=215578bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215578bf",
  null
  
)

export default component.exports